export const navigationHandlerRef: {
    current: (() => Promise<void>) | null;
} = {
    current: null,
};
